import React, { useState } from "react"
import { View } from "./primitives"

export default function Swiper({
  children,
  index = 0,
  onIndexChanged,
  horizontal = true,
  loop = false,
  showsButtons = false,
  autoplay = false,
  showsPagination = true,
  paginationStyle,
  dot,
  activeDot,
}: {
  children?: React.ReactNode
  index?: number
  onIndexChanged?: (i: number) => void
  horizontal?: boolean
  loop?: boolean
  showsButtons?: boolean
  autoplay?: boolean
  showsPagination?: boolean
  paginationStyle?: React.CSSProperties
  dot?: React.ReactNode
  activeDot?: React.ReactNode
}) {
  void horizontal
  void loop
  void showsButtons
  void autoplay

  const items = React.Children.toArray(children)
  const [current, setCurrent] = useState(index)
  const go = (i: number) => {
    setCurrent(i)
    onIndexChanged?.(i)
  }

  return (
    <View style={{ flex: 1, minHeight: 0, height: "100%", position: "relative", display: "flex" }}>
      <View style={{ flex: 1, minHeight: 0, overflow: "auto" }}>{items[current]}</View>
      {showsPagination && items.length > 1 ? (
        <View
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            flexDirection: "row",
            justifyContent: "center",
            gap: 8,
            ...paginationStyle,
          }}
        >
          {items.map((_, i) => (
            <button
              key={i}
              type="button"
              onClick={() => go(i)}
              style={{
                border: "none",
                background: "transparent",
                padding: 0,
                cursor: "pointer",
              }}
            >
              {i === current ? activeDot : dot}
            </button>
          ))}
        </View>
      ) : null}
    </View>
  )
}
